import { gql } from '@apollo/client';
import { DspValidationType } from '../../../../enums/DspValidationType';

// 验证订单是否存在及状态是否符合要求
export const VALIDATE_ORDER_EXISTS = gql`
  query ValidateOrderExists($trackingNumber: String!, $validationType: DspValidationType) {
    validateOrderExists(trackingNumber: $trackingNumber, validationType: $validationType)
  }
`;

export interface ValidateOrderExistsResponse {
  validateOrderExists: boolean;
}

export interface ValidateOrderExistsVariables {
  trackingNumber: string;
  validationType?: DspValidationType;
}
